<template>
  <div
    class="flex-grow flex items-center justify-center transition-opacity pointer-events-none"
    ref="target"
  >
    <p class="font-title uppercase Leading-none text-2-mob lg:text-3-desk">
      {{ end ? message : "LOADING MORE..." }}
    </p>
  </div>
</template>

<script>
export default {
  name: "BlockLazyLoadMore",

  props: {
    end: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    }
  },

  mounted() {
    this.observer = new IntersectionObserver(this.handleObservation);
    this.observer.observe(this.$refs.target);
  },

  methods: {
    handleObservation(entry) {
      if (this.end) return;
      if (entry[0].isIntersecting) this.$emit("loadMore");
    }
  }
};
</script>
